import script from "./addressBookPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./addressBookPopup.vue?vue&type=script&setup=true&lang=js"

import "./addressBookPopup.vue?vue&type=style&index=0&id=72f3f677&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f3f677"]])

export default __exports__